import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IconModule } from '../../../cms-components/misc/icon/icon.module';
import { PipesModule } from '../../pipes';
import { DropdownModule } from '../dropdown/dropdown.module';
import { ReactiveFormInputFieldModule } from '../reactive-forms-input/reactive-form-input-field/reactive-form-input-field.module';
import { CountryPhoneInputComponent } from './country-phone-input.component';

@NgModule({
  imports: [CommonModule, DropdownModule, ReactiveFormInputFieldModule, IconModule, ReactiveFormsModule, PipesModule],
  declarations: [CountryPhoneInputComponent],
  exports: [CountryPhoneInputComponent],
})
export class CountryPhoneInputModule {}
